import { Posting } from './posting.model';
import * as momentImported from 'moment';
const moment = momentImported;

/**
 * Transform Posting model to Posting Json for the API
 */
export class EditPostingFromArticleCommand {
    public posting_type: { id: string };
    public valid_from: string;
    public valid_to: string;

    constructor(tempPosting: Posting) {
        if (tempPosting) {
            this.posting_type = {
                id: tempPosting.postingType.id,
            };

            if (tempPosting.validFrom) {
                this.valid_from = moment(tempPosting.validFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            }

            if (tempPosting.validTo) {
                this.valid_to = moment(tempPosting.validTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
            }
        }
    }
}
